// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3SqIY","checkboxCol":"Table_checkboxCol__3MF4h","emailCol":"Table_emailCol__1DBtF","actionCol":"Table_actionCol__3fr2C"};